import { render, staticRenderFns } from "./BloodSampleReceiving.vue?vue&type=template&id=059ea099&scoped=true&"
import script from "./BloodSampleReceiving.vue?vue&type=script&lang=js&"
export * from "./BloodSampleReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ea099",
  null
  
)

export default component.exports